import {
  CLEAR_PREREGISTROS_ACTION,
  FETCH_PREREGISTRO_INFO,
  FETCH_PREREGISTROS,
  SEND_PREREGISTRO,
} from './actions.type';

import {
  SET_ERROR,
  FETCHING_PREREGISTROS,
  SET_PREREGISTROS,
  FETCHED_PREREGISTROS,
  CLEAR_PREREGISTROS,
  CLEAR_PREREGISTRO_INFO,
  SET_PREREGISTRO,
  STARTED_PREREGISTRO_PROCESSING,
  RESET_PREREGISTRO_PROCESSING,
  SUBMITED_PREREGISTRO,
  SUBMIT_PREREGISTRO_ERROR,
  RESET_PREREGISTRO_SUBMIT,
  CLEAR_ALERT_DIALOG,
} from './mutations.type';
import ApiService from '../common/api.service';

/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

const state = {
  alert: false,
  alertMessage: '',
  alertType: 'success',
  alertDialog: false,
  alertDialogMessage: '',
  alertDialogType: 'success',
  loading_preregistros: false,
  processing_preregistro: false,
  submited_preregistro: false,
  preregistro_list: [],
  preregistro_info: {},
};

const getters = {
  is_loading() {
    return state.loading_preregistros;
  },
  preregistro_list() {
    return state.preregistro_list;
  },
  preregistro_info() {
    return state.preregistro_info;
  },
  preregistro_submited() {
    return state.submited_preregistro;
  },
  preregistro_processing() {
    return state.processing_preregistro;
  },
  alertContainer(state) {
    return state.alert;
  },
  alertContainerMessage(state) {
    return state.alertMessage;
  },
  alertContainerType(state) {
    return state.alertType;
  },
  alertDialog(state) {
    return state.alertDialog;
  },
  alertDialogMessage(state) {
    return state.alertDialogMessage;
  },
  alertDialogType(state) {
    return state.alertDialogType;
  },
};

const actions = {
  [SEND_PREREGISTRO](context, data) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      const toSend = {
        observation: data.observation,
        walkin_id: data.walkin_id,
      };
      let toSendUrl = 'accesos/reject_walkin';
      if (data.status === 'ACEPTADO') {
        toSendUrl = 'accesos/convert_walkin';
      }
      ApiService.post(toSendUrl, toSend, {
      })
        .then(({ data }) => {
          context.commit(SUBMITED_PREREGISTRO, data);
          resolve(data);
          context.commit(CLEAR_PREREGISTRO_INFO);
          context.dispatch(FETCH_PREREGISTROS);
        })
        .catch(({ response }) => {
          if (typeof response === 'undefined') {
            context.commit(SUBMIT_PREREGISTRO_ERROR, 'Error de Red. No se guardó la información.');
          } else {
            context.commit(SUBMIT_PREREGISTRO_ERROR, response.data.message);
          }
          context.commit(RESET_PREREGISTRO_PROCESSING);
        });
    });
  },
  [FETCH_PREREGISTROS](context) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(FETCHING_PREREGISTROS);
      ApiService.query('accesos/walkins')
        .then(({ data }) => {
          context.commit(SET_PREREGISTROS, data);
          context.commit(FETCHED_PREREGISTROS);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_PREREGISTROS);
        });
    });
  },
  [FETCH_PREREGISTRO_INFO](context, id) {
    return new Promise((resolve) => {
      ApiService.setHeader();
      context.commit(FETCHING_PREREGISTROS);
      context.commit(CLEAR_PREREGISTRO_INFO);
      const url = `accesos/walkins/${id}`;
      ApiService.query(url)
        .then(({ data }) => {
          context.commit(SET_PREREGISTRO, data);
          context.commit(FETCHED_PREREGISTROS);
          resolve(data);
        })
        .catch(({ response }) => {
          context.commit(SET_ERROR, [response.data.message]);
          context.commit(FETCHED_PREREGISTROS);
        });
    });
  },
  [CLEAR_PREREGISTROS_ACTION](context) {
    context.commit(CLEAR_PREREGISTROS);
  },
};

const mutations = {
  [FETCHING_PREREGISTROS](state) {
    state.loading_preregistros = true;
  },
  [SET_PREREGISTROS](state, data) {
    state.preregistro_list = data.walkins;
  },
  [SET_PREREGISTRO](state, data) {
    state.preregistro_info = data.walkin;
  },
  [FETCHED_PREREGISTROS](state) {
    state.loading_preregistros = false;
  },
  [CLEAR_PREREGISTROS](state) {
    state.preregistro_list = [];
  },
  [CLEAR_PREREGISTRO_INFO](state) {
    state.preregistro_info = {};
  },
  [STARTED_PREREGISTRO_PROCESSING](state) {
    state.processing_preregistro = true;
  },
  [RESET_PREREGISTRO_PROCESSING](state) {
    state.processing_preregistro = false;
  },
  [SUBMITED_PREREGISTRO](state, data) {
    state.submited_preregistro = true;
    state.alert = true;
    state.alertType = 'success';
    state.alertMessage = data.message;
  },
  [SUBMIT_PREREGISTRO_ERROR](state, data) {
    state.submited_preregistro = false;
    state.alertDialog = true;
    state.alertDialogType = 'error';
    state.alertDialogMessage = data;
  },
  [RESET_PREREGISTRO_SUBMIT](state) {
    state.submited_preregistro = false;
    state.alert = false;
    state.alertMessage = 'default';
    state.alertType = 'warning';
  },
  [CLEAR_ALERT_DIALOG](state) {
    state.alertDialog = false;
    state.alertDialogMessage = '';
    state.alertDialogType = 'success';
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
